import { isVueAppInDOM, renderApp } from '@/src/utilities/component-utilities';

import ROICalculator from './ROICalculator.vue';

export function load() {
  if (!isVueAppInDOM('roi-calculator')) {
    return;
  }

  renderApp(ROICalculator, 'roi-calculator');
}
